import { z } from 'zod';
import { concurrency, emptyAsNull, id, moneyAmount, optionalText, ymd } from './common';

/**
 * Month-end actuals. Daily entries are estimates; once a month is over the
 * real figures are recorded per account:
 *  - revenue: the payout actually received (after network deductions, in the
 *    account currency) and the ₹ actually credited to the bank;
 *  - ads: the invalid-click credit given back by the platform.
 * Estimated amounts are never changed; reports show Estimated → Adjustment → Actual.
 */
const year = z.coerce.number().int().min(2000).max(2100);
const month = z.coerce.number().int().min(1).max(12);

export const monthQuerySchema = z.object({ year, month });
export type MonthQuery = z.output<typeof monthQuerySchema>;

export const settlementParams = z.object({ accountId: id, year, month });

export const revenueSettlementSchema = z.object({
  /** Payout after deductions, in the account currency. */
  actualAmount: moneyAmount,
  /** ₹ credited to the bank (net of bank charges). Empty = not received yet. */
  actualInr: emptyAsNull(moneyAmount),
  receivedDate: emptyAsNull(ymd),
  reference: optionalText(100),
  notes: optionalText(2000),
  ...concurrency,
});
export type RevenueSettlementInput = z.output<typeof revenueSettlementSchema>;

export const adSettlementSchema = z.object({
  /** Invalid-click / traffic credit, before GST, in the account currency. */
  invalidClickCredit: moneyAmount,
  notes: optionalText(2000),
  ...concurrency,
});
export type AdSettlementInput = z.output<typeof adSettlementSchema>;
